import auth from '../middleware/auth';
import requiresPasswordChange from '../middleware/user-password-change';

export default [{
    path: 'profils',
    name: 'user-profile',
    meta: {
        middleware: [auth, requiresPasswordChange],
    },
    component: () => import('@/views/site/Profile'),
  },
  {
      path: 'change-password',
      name: 'user-password-change',
      meta: {
            middleware: [auth]
    },
      component: () => import('@/components/users/UserPasswordChange')
}]
    